<template>
	<!--<div class="container-fluid no-padding-sides" v-for="banner in Banners">
		<h4 class="title-center">{{banner.title}}</h4>
		<div class="col-sm-12">
				<div>
				<img class="img-responsive" v-bind:src="banner.img" alt="banner">
				</div>
				<div class="carousel-caption-white">
					<p>{{banner.caption}}</p>
				</div>
		</div>
	</div>-->
	<div class="container-fluid no-padding-sides">
		<h2 class="title-center no-margin-top no-padding-top">Inspiración Lasddi</h2>
		<div class="col-sm-12">
			<div class="banner-image banner-inspiracion pointer" :style="'background-image: url(' + setUrlImage() + ')'" v-link="{ path: '/proyectos-contract' }">
				<!-- <div class="carousel-caption-white bottom-extra">
					<p>Inspiración Lasddi</p>
				</div> -->
			</div>
		</div>
	</div>
</template>

<style scoped>
	.col-sm-12 {
		padding-bottom: 0;
	}
</style>

<script>
	// import img1 from '../images/banner-contract.png';
	// import img2 from '../images/banner-about.png';
	import { api_base } from '../store/api'

	export default{
		data: function () {
			return {
				admin_base: 'https://admin.lasddi.com',
			}
		},

		methods: {
			setUrlImage () {
				return `${this.admin_base}/storage/banners/banner_1.jpeg`
			}
		}
		// data: function() {
		// 	return{
		// 		Banners: [
		// 			{
		// 				title: "Desarrollos",
		// 				img: img1,
		// 				caption: "Del taller a tu hogar"
		// 			},
		// 			{
		// 				title: "Acerca de Lasddi",
		// 				img: img2,
		// 				caption: "Creamos nuevos estándares"
		// 			},
		// 		],
		// 	};
		// },
	};
</script>


// WEBPACK FOOTER //
// Banner.vue?464a5f7f